<template>
    <div class="eda-status" :class="'eda-status--' + value">
        <template v-if="editable">

            <div class="eda-status__editable">

                <select @change="updateStatus()" v-model="value" :class="'eda-status--' + value"
                        class="eda-status__select">
                    <template v-for="label, key in options">
                        <option class="eda-status__option" :value="key">{{label}}</option>
                    </template>
                </select>
                <icon class="eda-status__caret" icon="caret"></icon>
            </div>
        </template>
        <template v-else>
            <div> {{ label }}</div>
        </template>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import axios from 'axios'
    import apiMixin from '../mixins/apiMixin.js'
    import icon from "./vIcon"
    import STATUS from "../config/status/order.js"
    import INSTALLATION_STATUS from "../config/status/installer.js"

    export default {
        name: "EdaStatus",
        mixins: [apiMixin.apiMixin],
        components: {
            icon
        },
        props: {
            id: {type: String, default: ""},
            editable: {type: Boolean, default: false},
            status: {type: String, default: ""},
            options: {
                type: Object, default: function () {
                    let opt = {};
                    let statuses = [...STATUS, ...INSTALLATION_STATUS];

                    for (let key in statuses) {
                        opt[statuses[key].value] = statuses[key].label;
                    }
                    return opt
                }
            },
        },

        data() {
            return {
                value: this.status,
            }
        },
        methods: {

            updateStatus() {
                let that = this;
                that.submitting = true;
                console.log(that.apiHeaders);
                axios.patch(process.env.VUE_APP_API_URL + "/orders/" + that.id, {
                    orderStatus: that.value
                }, that.apiHeaders).then(function (response) {
                    that.savingError = false;
                }).catch(function (error) {
                    that.savingError = true;
                    console.log(error);
                }).finally(function () {
                    that.submitting = false;
                });
            }
        },
        computed: {
            label() {
                return this.options[this.status];
            },
        }
    }
</script>

<style scoped>

    .eda-status__select {
        font-weight: 600;
        font-size: 1em;
        width: 100%;

        padding: 0.2em 0;
        color: inherit;
        border: none;
        border-radius: 0.2em;
        cursor: pointer;
        outline: none;
        -webkit-appearance: none;
    }

    .eda-status__option {
        padding: 1em;
        color: #555;
    }

    .eda-status__editable {
        position: relative;
    }

    .eda-status__caret {
        opacity: 0;
        width: 0.75em;
        position: absolute;
        top: 0;
        pointer-events: none;
        right: 0;
        transition: all 0.2s ease;
    }

    .eda-status__editable:hover .eda-status__caret {
        opacity: 1;
        fill: #00B27C;
    }

    .eda-status--other,
    .eda-status--houseApprovalNeeded,
    .eda-status--customerFacilitationNeeded,
    .eda-status--weatherConditioned,
    .eda-status--gridApprovalNeeded,
    .eda-status--partsNeeded,
    .eda-status--hardwareWanted,
    .eda-status--paused {
        color: #e8b200;
    }

    .eda-status--assigned,
    .eda-status--gridPermissionApplied,
    .eda-status--installationDateSet,
    .eda-status--installationAgreed,
    .eda-status--orderReceived {
        color: #0AB8A6;
    }


    .eda-status--revoked,
    .eda-status--deleted
    {
        color: #e38e91
    }


    .eda-status--completed,
    .eda-status--installed {
        color: #00A110
    }

    .eda-status--unassigned {
        color: #787878
    }

</style>